/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScorecardOutcome = {
    Pass: 'Pass',
    Fail: 'Fail',
    Discarded: 'Discarded',
    Testing: 'Testing'
} as const;
export type ScorecardOutcome = typeof ScorecardOutcome[keyof typeof ScorecardOutcome];


export function ScorecardOutcomeFromJSON(json: any): ScorecardOutcome {
    return ScorecardOutcomeFromJSONTyped(json, false);
}

export function ScorecardOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardOutcome {
    return json as ScorecardOutcome;
}

export function ScorecardOutcomeToJSON(value?: ScorecardOutcome | null): any {
    return value as any;
}

